import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=63f8a21d&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=63f8a21d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8a21d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f8a21d')) {
      api.createRecord('63f8a21d', component.options)
    } else {
      api.reload('63f8a21d', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=63f8a21d&scoped=true", function () {
      api.rerender('63f8a21d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Settings.vue"
export default component.exports